import React from 'react';
import { BrowserRouter, Route, Router, Switch, Redirect } from 'react-router-dom';
import Scroll from './Screens/Scroll.js'
import history from './history'

// import Page from './Screens/LandingPage'
import Dashboard from './Screens/Dashboard/Dashboard'
import Openorder from './Screens/OpenOrder'
import LookupResult from './Screens/LookupOrder'
import Completedorder from './Screens/CompletedOrder'
import Orderlookup from './Screens/OrderLookup/OrderLookup'
import EditVendor from './Screens/EditVendor'
import Orderlog from './Screens/Orderlogfinal'
import Account from './Screens/AccountInfo'
import MyLenders from './Screens/MyLenders'
import AddLender from './Screens/AddLender'
import EditLender from './Screens/EditLender'
import LenderOrders from './Screens/LenderOrders'
import AddOrder from './Screens/AddOrder'
import EditOrder from './Screens/EditOrder'
import LenderProducts from './Screens/LenderProducts'
import AddProduct from './Screens/AddProduct'
import EditProduct from './Screens/EditProduct'
import Attachments from './Screens/Attachments'
import ProductResponses from './Screens/ProductResponses'
import AddResponse from './Screens/AddResponse'
import EditResponse from './Screens/EditResponse'
import Transaction from './Screens/Transactions'
import Details from './Screens/Details'
import Login from './Screens/LoginPage/LoginPage'
import ForgotPassword1 from './Screens/Forgot/ForgotPassword1';
import ForgotPassword2 from './Screens/Forgot/ForgotPassword2';
import ForgotPassword3 from './Screens/Forgot/ForgotPassword3';

function App() {

  const token = localStorage.getItem('token');
  let isAuthenticated = false;
  if(token){
      isAuthenticated = true
  }
  
  return (
    <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
      <Scroll />
      <Router history={history}>
        {!isAuthenticated 
        ? <Switch>
            <Route path="/Login" component={Login} />
            <Route path="/Forgot" component={ForgotPassword1} />
            <Route path="/Otp" component={ForgotPassword2} />
            <Route path="/Reset" component={ForgotPassword3} />
            <Redirect to="/Login" />
        </Switch>
        : <Switch>
            <Route path="/" exact component={Dashboard} />
            <Route path="/Dashboard" component={Dashboard} />
            <Route path="/Openorder" component={Openorder} />
            <Route path="/Completedorder" component={Completedorder} />
            <Route path="/Orderlookup" component={Orderlookup} />
            <Route path="/OrderLookupResult" component={LookupResult} />
            <Route path="/Orderlog" exact component={Orderlog} />
            <Route path="/Orderlog/:id" component={Orderlog} />
            <Route path="/Account" component={Account} />
            <Route path="/Transaction" component={Transaction} />
            <Route path="/Details/:id" component={Details} />
            <Route path="/MyLenders" exact component={MyLenders} />
            <Route path="/MyLenders/add" component={AddLender} />
            <Route path="/MyLenders/:lenderId/edit" component={EditLender} />
            <Route path="/MyLenders/orders/:lenderId" exact component={LenderOrders} />
            <Route path="/MyLenders/orders/:lenderId/add" component={AddOrder} />
            <Route path="/MyLenders/orders/:lenderId/edit/:orderId" component={EditOrder} />
            <Route path="/MyLenders/products/:lenderId" exact component={LenderProducts} />
            <Route path="/MyLenders/products/:lenderId/add" component={AddProduct} />
            <Route path="/MyLenders/products/:lenderId/edit/:productId" component={EditProduct} />
            <Route path="/MyLenders/products/:lenderId/responseInputs/:productId" exact component={ProductResponses} />
            <Route path="/MyLenders/products/:lenderId/responseInputs/:productId/add" exact component={AddResponse} />
            <Route path="/MyLenders/products/:lenderId/responseInputs/:productId/edit/:responseId" exact component={EditResponse} />
            <Route path="/Editvendor" component={EditVendor} />
            <Route path="/Attachments/:orderId" component={Attachments} /> 
            <Redirect to="/Dashboard" />
        </Switch>
      }
      </Router>
    </BrowserRouter>
  );
}

export default App;